import { render, staticRenderFns } from "./Nft.vue?vue&type=template&id=16331250"
import script from "./Nft.vue?vue&type=script&lang=js"
export * from "./Nft.vue?vue&type=script&lang=js"
import style0 from "./Nft.vue?vue&type=style&index=0&id=16331250&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports